import { Link, Menu, MenuItem } from "@mui/material"

const ContractsActionMenu = ({
    currentContract, anchorEl, open, onClose,
    actionNamesMap, actionHandlersMap, actionsIsLoading, onOpenHistory
}) => <Menu
    id="contract-actions"
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
>
        {currentContract?.available_actions?.map(action => <MenuItem
            onClick={actionHandlersMap[action]}
            key={action}
            disabled={actionsIsLoading}
        >
            {actionNamesMap[action] ?? action}
        </MenuItem>)}
        <MenuItem
            onClick={onOpenHistory}
            disabled={currentContract?.history?.length === 0}
        >
            История
        </MenuItem>
        <MenuItem
            href={currentContract?.file}
            component={Link}
            disabled={!currentContract?.file}
            target="_blank"
        >
            Скачать договор
        </MenuItem>
        <MenuItem
            href={currentContract?.file_signed_by_entrant}
            component={Link}
            disabled={!currentContract?.file_signed_by_entrant}
            target="_blank"
        >
            Скачать договор, подписанный абитуриентом
        </MenuItem>
        <MenuItem
            href={currentContract?.file_signed_on_both_sides}
            component={Link}
            disabled={!currentContract?.file_signed_on_both_sides}
            target="_blank"
        >
            Скачать договор, подписанный обеими сторонами
        </MenuItem>
    </Menu>

export default ContractsActionMenu